import GeoService from '../services/geo-service';
import { setLoading, setLoaded, setError } from './index';
import { deleteAllNumbers } from '../utils/utils';


export const weatherRequested = () => ({
  type: 'WEATHER_REQUESTED',
});

export const weatherLoaded = (data) => ({
  type: 'WEATHER_LOADED',
  payload: data,
});

export const weatherError = (err) => ({
  type: 'WEATHER_ERROR',
  payload: err,
});

export const conditionLoaded = (data) => ({
  type: 'CONDITION_LOADED',
  payload: data,
});

export const nextDaysTempLoaded = (data) => ({
  type: 'NEXT_DAYS_TEMP_LOADED',
  payload: data,
});

export const weatherInfoLoaded = (data) => ({
  type: 'WEATHER_INFO_LOADED',
  payload: data,
});

export const weatherDayTimeLoaded = (data) => ({
  type: 'DAYTIME_LOADED',
  payload: data,
});

export const dateLoaded = (data) => ({
  type: 'DATE_LOADED',
  payload: data,
});

const weatherService = new GeoService();

export const fetchWeather = (lat, lon, lang) => (dispatch) => {
  dispatch(setLoading());
  weatherService.getWeather(lat, lon, lang)
    .then((data) => {
      dispatch(setLoaded());
      const nextDaysTemp = [];
      const infoWeather = {
        feelsLike: Math.floor(data.current.feels_like),
        wind: Math.floor(data.current.wind_speed),
        id: data.current.weather[0].id,
        humidity: data.current.humidity,
        date: data.timezone,
      };
      const days = 4;
      for (let i = 1; i < days; i += 1) {
        const res = {};
        res.contidion = data.daily[i].weather[0].description;
        res.id = data.daily[i].weather[0].id;
        res.temp = Math.floor(data.daily[i].temp.day);
        res.dt = data.daily[i].dt * 1000;
        nextDaysTemp.push(res);
      }
      dispatch(conditionLoaded(data.current.weather[0].description));
      dispatch(weatherInfoLoaded(infoWeather));
      dispatch(nextDaysTempLoaded(nextDaysTemp));
      dispatch(weatherLoaded(Math.floor(data.current.temp)));
      dispatch(weatherDayTimeLoaded(deleteAllNumbers(data.current.weather[0].icon)));
      dispatch(dateLoaded(data.current.dt * 1000));
    })
    .catch((err) => {
      dispatch(setError(err.message));
    });
};
